import React from 'react';
import Link from 'next/link';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { CollapseLine } from '..';
import { whyKeenData } from './whyKeenData';
import { WhyKeenContainer } from './styled';

export default function WhyKeen(): JSX.Element {
  return (
    <WhyKeenContainer>
      <Typography variant="h2" component="div" marginBottom="30px">
        Why Keen?
      </Typography>
      <Typography
        className="why-keen-content"
        data-testid="sub-heading"
        variant="body2"
        component="div"
        sx={{
          '& a': {
            textDecoration: 'none',
            color: 'teal',
            ':hover': {
              color: '#5fcac8',
              cursor: 'pointer'
            }
          }
        }}>
        {`
          You've finally decided that you want to seek psychic advice, but now
          you're asking yourself, "Why Keen?" "Shouldn't I just look into
          psychics near me?" Our response: "Why would you?" We've been giving
          trust-worthy readings since 1999 - over 35 million, to be exact - but
          in case you need a little more convincing, here are  three fantastic
          reasons why you should `}
        <Link href="/all-categories">book a psychic</Link> through Keen.
        <Box mt={5}>
          {whyKeenData.map((item) => (
            <CollapseLine
              key={item.title}
              title={item.title}
              text={item.text}
            />
          ))}
        </Box>
      </Typography>
    </WhyKeenContainer>
  );
}
